import React, { useCallback, useEffect, useState, useRef, createElement } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FileText, Zap, Baby, Globe, Star, Users, BookOpen, Heart, ShieldCheck, Lock, ArrowRight, ChevronDown, ChevronLeft, ChevronRight, X, Trophy, Dumbbell, Sparkles } from 'lucide-react';
function useMetaPixel() {
  useEffect(() => {
    const pixelId = '1533498074889369';
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '${pixelId}');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, []);
}
export function LandingPage() {
  useMetaPixel();
  return <div className="font-sans text-carbon bg-cream min-h-screen" data-id="element-2">
      {/* TOPBAR */}
      <div className="bg-carbon text-cream text-center py-2.5 px-6 text-[13px] font-medium tracking-wide" data-id="element-3">
        Edición Esencial disponible ·{' '}
        <span className="text-terra-mid" data-id="element-4">
          10 PDFs · Descarga inmediata · Mercado Pago
        </span>
      </div>

      {/* HERO */}
      <section className="bg-cream pt-20 pb-20 px-6 text-center border-b border-border" data-id="element-5">
        <div className="max-w-[960px] mx-auto flex flex-col items-center" data-id="element-6">
          <div className="inline-block bg-terra text-white text-[11px] font-bold tracking-widest uppercase py-1.5 px-4 rounded-full mb-8 shadow-sm" data-id="element-7">
            Nuevo · Producto Digital
          </div>

          <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-black leading-tight text-carbon mb-6 max-w-[800px] tracking-tight" data-id="element-8">
            En 4 semanas cambiás <br className="hidden md:block" data-id="element-9" /> el hábito de
            pantallas <br className="hidden md:block" data-id="element-10" /> de tu familia{' '}
            <em className="italic text-terra" data-id="element-11">para siempre</em>
          </h1>

          <p className="text-lg md:text-xl text-carbon-soft mb-10 max-w-[600px] leading-relaxed" data-id="element-12">
            Sin gritos, sin negociaciones eternas, sin culpa.{' '}
            <br className="hidden md:block" data-id="element-13" />
            Con un plan claro, actividades listas y frases reales para cada
            momento difícil.
          </p>

          <div className="w-full max-w-[800px] mb-10" data-id="element-14">
            <img src="https://cdn.magicpatterns.com/uploads/5Ueffs5zUHyoR1xsPY8ZPz/Gemini_Generated_Image_gnn3v4gnn3v4gnn3-fotor-bg-remover-202606281343.png" alt="Jugar, Crecer, Conectar - Guía Completa" className="w-full h-auto object-contain drop-shadow-2xl" data-id="element-15" />
          </div>

          <div className="bg-terra-light border-l-4 border-terra rounded-r-xl p-5 md:p-6 max-w-[600px] mx-auto mb-10 text-left text-base md:text-lg font-medium text-carbon" data-id="element-16">
            <strong className="text-terra" data-id="element-17">Jugar, Crecer, Conectar</strong> —
            Guía práctica para acompañar a niños de 2 a 12 años a vivir más y
            mejor fuera de las pantallas.{' '}
            <strong className="text-terra" data-id="element-18">
              10 PDFs listos para usar desde hoy.
            </strong>
          </div>

          <div className="flex justify-center gap-6 flex-wrap text-[13px] text-carbon-soft mb-10" data-id="element-19">
            <span className="flex items-center gap-1.5" data-id="element-20">
              <FileText size={16} data-id="element-21" /> PDF Digital
            </span>
            <span className="flex items-center gap-1.5" data-id="element-22">
              <Zap size={16} data-id="element-23" /> Acceso inmediato
            </span>
            <span className="flex items-center gap-1.5" data-id="element-24">
              <Baby size={16} data-id="element-25" /> Niños de 2 a 12 años
            </span>
            
          </div>

          <a href="#pricing" className="inline-flex items-center justify-center bg-terra text-white font-semibold text-base py-4 px-10 rounded-lg hover:bg-terra-dark hover:-translate-y-0.5 transition-all duration-200 tracking-wide" data-id="element-26">
            QUIERO EMPEZAR HOY
          </a>
          <p className="text-[13px] text-carbon-soft mt-3" data-id="element-27">
            Garantía de 7 días · Pago seguro · Mercado Pago
          </p>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section className="bg-sand py-16 px-6 border-y border-border" data-id="element-28">
        <div className="max-w-[960px] mx-auto" data-id="element-29">
          <TestimonialsSlider data-id="element-30" />
        </div>
      </section>

      {/* PAIN SECTION */}
      <section className="py-20 px-6 bg-cream" data-id="element-31">
        <div className="max-w-[780px] mx-auto" data-id="element-32">
          <p className="text-[11px] font-bold tracking-widest uppercase text-terra mb-3" data-id="element-33">
            ¿Te pasa esto?
          </p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold leading-tight mb-4 text-carbon" data-id="element-34">
            Si tenés un hijo de 2 a 12 años, <br className="hidden md:block" data-id="element-35" />
            esto te suena familiar
          </h2>
          <p className="text-lg text-carbon-soft mb-10 max-w-[560px]" data-id="element-36">
            No hace falta que pase todo. Con que reconozcas dos o tres ya sabés
            de qué estamos hablando.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-37">
            <PainItem title="El drama de apagar la pantalla" desc="Cada vez que hay que terminar el tiempo de pantalla termina en llanto, gritos o negociación eterna." data-id="element-38" />
            <PainItem title='"Me aburro" cada cinco minutos' desc="Apenas no hay pantalla, el niño no sabe qué hacer solo. Y vos tampoco sabés qué proponerle." data-id="element-39" />
            <PainItem title="Culpa constante" desc="Sabés que hay demasiada pantalla pero no sabés cómo cambiarlo sin que sea una guerra diaria." data-id="element-40" />
            <PainItem title="Los abuelos que no ayudan" desc="En casa hay reglas, pero en lo de los abuelos todo vale. Y el niño aprovecha cada diferencia." data-id="element-41" />
            <PainItem title="Él prefiere la pantalla a todo" desc="Juegos de mesa, salir al parque, leer. Nada le parece tan interesante como el celular o la tele." data-id="element-42" />
            <PainItem title="No sabés qué decir en el momento" desc="Cuando tu hijo explota al sacarle la pantalla, las palabras correctas no aparecen. Y terminás cediendo." data-id="element-43" />
            <PainItem title="Cumpleaños y reuniones" desc='Todos los chicos tienen celular. El tuyo dice que es "el raro". No sabés cómo manejarlo.' data-id="element-44" />
            <PainItem title="Sabés que algo tiene que cambiar" desc="Pero no sabés por dónde empezar, cuánto cambiar, ni cómo sostenerlo sin abandonar a la semana." data-id="element-45" />
          </div>

          <p className="mt-12 text-center font-serif text-xl md:text-2xl italic text-carbon-soft" data-id="element-46">
            ¿Cuántos meses más vas a esperar para que algo cambie solo?
          </p>
        </div>
      </section>

      {/* FOR WHOM */}
      <section className="bg-sand py-20 px-6 border-y border-border" data-id="element-47">
        <div className="max-w-[780px] mx-auto" data-id="element-48">
          <p className="text-[11px] font-bold tracking-widest uppercase text-terra mb-3" data-id="element-49">
            ¿Para quién es?
          </p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold leading-tight text-carbon" data-id="element-50">
            Diseñado para vos si querés <br className="hidden md:block" data-id="element-51" />
            hacer algo diferente con las pantallas
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-10" data-id="element-52">
            <ForWhomCard icon={<Users className="text-terra" size={28} data-id="element-54" />} title="Papás y mamás con hijos de 2 a 12 años" desc="Que quieren reducir el tiempo de pantalla sin que sea una guerra diaria." data-id="element-53" />
            <ForWhomCard icon={<BookOpen className="text-terra" size={28} data-id="element-56" />} title="Docentes de nivel inicial y primario" desc="Que necesitan herramientas para hablar del tema con las familias sin generar conflicto." data-id="element-55" />
            <ForWhomCard icon={<Heart className="text-terra" size={28} data-id="element-58" />} title="Abuelos y cuidadores" desc="Que pasan tiempo con los niños y quieren saber cómo entretenerlos sin depender de una pantalla." data-id="element-57" />
            <ForWhomCard icon={<Zap className="text-terra" size={28} data-id="element-60" />} title="Familias que quieren empezar desde cero" desc="Que no saben por dónde empezar pero saben que algo tiene que cambiar." data-id="element-59" />
          </div>

          <p className="mt-8 text-center text-sm text-carbon-soft" data-id="element-61">
            ¿No estás seguro si es para vos? Tenés 7 días de garantía completa.{' '}
            <a href="#guarantee" className="text-terra underline hover:text-terra-dark" data-id="element-62">
              Ver garantía →
            </a>
          </p>
        </div>
      </section>

      {/* STATS BAR */}
      <div className="bg-carbon py-10 px-6" data-id="element-63">
        <div className="max-w-[780px] mx-auto flex justify-center gap-8 md:gap-12 flex-wrap text-center" data-id="element-64">
          <StatItem num="10" label="PDFs incluidos" data-id="element-65" />
          <StatItem num="170" label="Páginas de contenido" data-id="element-66" />
          <StatItem num="100+" label="Actividades sin pantalla" data-id="element-67" />
          <StatItem num="50" label="Frases listas para usar" data-id="element-68" />
          <StatItem num="4" label="Semanas de plan estructurado" data-id="element-69" />
        </div>
      </div>

      {/* CONTENT */}
      <section className="py-20 px-6 bg-cream" data-id="element-70">
        <div className="max-w-[780px] mx-auto" data-id="element-71">
          <p className="text-[11px] font-bold tracking-widest uppercase text-terra mb-3" data-id="element-72">
            Contenido completo
          </p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold leading-tight mb-4 text-carbon" data-id="element-73">
            Los 6 tomos principales
          </h2>
          <p className="text-lg text-carbon-soft mb-10" data-id="element-74">
            Tu hoja de ruta completa para cambiar el hábito de pantallas, semana
            a semana.
          </p>

          <p className="text-[13px] text-carbon-soft mb-6 -mt-6" data-id="element-75">
            Tocá cada tomo para ver el detalle.
          </p>

          <div className="flex flex-col gap-2.5" data-id="element-76">
            <ModuleItem defaultOpen num="1" title="Pantallas y niños — Lo que todo adulto debería saber" desc="La información real sobre el impacto del uso cotidiano de pantallas, explicada en lenguaje de familia. Sin alarmar, con datos que podés usar mañana mismo." tags={['Qué dice la OMS', 'Sueño y atención', 'Pantalla pasiva vs interactiva']} data-id="element-77" />
            <ModuleItem num="2" title="¿Cuánto es demasiado? — Una mirada honesta al uso cotidiano" desc="Sin culpa y sin comparaciones. Herramientas para entender el punto de partida real de tu familia y saber desde dónde querés avanzar." tags={['Registro de uso real', 'Señales de alerta', 'Tu perfil de punto de partida']} data-id="element-78" />
            <ModuleItem num="3" title="El cambio paso a paso — Cómo avanzar sin que sea una batalla campal" desc="Estrategias concretas para reducir el tiempo de pantalla de forma gradual. Cómo hablarle a tu hijo según su edad y cómo alinear a todos los adultos del entorno." tags={['Frases por edad', 'La técnica del reemplazo', 'Alinear adultos']} data-id="element-79" />
            <ModuleItem num="4" title="100 actividades sin pantallas — Por edad y por momento del día" desc="El tomo más consultado. 100 actividades concretas con materiales simples que cualquier familia puede empezar hoy mismo. Por rango de edad y por momento del día." tags={['2 a 4 años', '5 a 7 años', '8 a 12 años', 'Días difíciles']} data-id="element-80" />
            <ModuleItem num="5" title="Cuando el mundo no acompaña — Situaciones difíciles con soluciones reales" desc="El tomo que ninguna otra guía tiene. Escenarios reales donde sostener la decisión se complica, con respuestas concretas para cada uno." tags={['Cumpleaños con celulares', 'Los abuelos', 'Viajes y esperas', 'La pareja no acuerda']} data-id="element-81" />
            <ModuleItem num="6" title="Menos pantallas, más vos — Tu plan para las próximas 4 semanas" desc="El cierre accionable. Un plan semana a semana, flexible y adaptable, que convierte todo lo leído en movimiento real. Para familias y para docentes." tags={['Plan semana a semana', 'Herramientas imprimibles', 'Versión para el aula']} data-id="element-82" />

            <div className="mt-6 mb-2" data-id="element-83">
              <div className="bg-sage text-white text-center py-3 px-4 rounded-xl font-serif text-lg font-bold tracking-wide" data-id="element-84">
                ✦ Edición Completa — Tomos exclusivos ✦
              </div>
              <p className="text-center text-[13px] text-carbon-soft mt-3 px-4" data-id="element-85">
                Por solo $10.000 más, sumás estos 2 tomos avanzados —{' '}
                <strong className="text-carbon" data-id="element-86">40 páginas extra</strong> de
                contenido que solo viene con la Edición Completa.
              </p>
            </div>

            <ModuleItem num="7" title="Vínculos que compiten con cualquier pantalla — Conexión real en un mundo de notificaciones" desc="El tomo más reflexivo y emocional del set. Qué es la presencia plena, el rol del juego libre, cómo los rituales pequeños construyen el vínculo más fuerte que cualquier pantalla." tags={['Presencia plena', 'Juego libre', 'Rituales', 'El adulto también', 'Para docentes']} isExclusive data-id="element-87" />
            <ModuleItem num="8" title="Cuando llegue el momento — Cómo preparar a tu hijo para su primera pantalla" desc="Para quienes no quieren eliminar las pantallas para siempre, sino preparar a sus hijos para usarlas con criterio. A qué edad, en qué condiciones y con qué acuerdos." tags={['Primera pantalla', 'Acuerdo digital familiar', 'Autonomía progresiva', 'Redes sociales', 'Cuándo empezar']} isExclusive data-id="element-88" />
          </div>
        </div>
      </section>

      {/* BONUSES */}
      <section className="bg-sand py-20 px-6 border-y border-border" data-id="element-89">
        <div className="max-w-[780px] mx-auto" data-id="element-90">
          <p className="text-[11px] font-bold tracking-widest uppercase text-terra mb-3" data-id="element-91">
            Incluidos gratis
          </p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold leading-tight mb-4 text-carbon" data-id="element-92">
            4 bonos estratégicos
          </h2>
          <p className="text-lg text-carbon-soft mb-10" data-id="element-93">
            Sin costo extra. Incluidos en la Edición Esencial.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-94">
            <BonusCard num="1" title="50 frases para responder con calma en los momentos difíciles" desc="Lo que decir cuando tu hijo llora al apagar la pantalla, pide más tiempo, compara con otros o dice que se aburre. Organizadas por situación, listas para usar." data-id="element-95" />
            <BonusCard num="2" title="La semana en familia — Esquema de rutina semanal imprimible" desc="Tres rutinas base (semana, fin de semana y vacaciones) más una plantilla en blanco para personalizar. Para pegar en la heladera y que todos la vean." data-id="element-96" />
            <BonusCard num="3" title="20 actividades exprés — Tarjetas para pegar en la heladera" desc='Para cuando tu hijo dice "me aburro" y necesitás una respuesta en cinco segundos. Imprimí, recortá y pegá. Cada tarjeta: una actividad sin pantalla, con materiales que ya tenés.' data-id="element-97" />
            <BonusCard num="4" title="El adulto también — Mini guía para revisar tu propia relación con el celular" desc="Porque los niños aprenden mirando. Una guía honesta y sin juicio para que el adulto evalúe su propio uso y pueda dar el ejemplo que quiere ver." data-id="element-98" />
          </div>

          <div className="mt-10 mb-4" data-id="element-99">
            <div className="bg-sage text-white text-center py-3 px-4 rounded-xl font-serif text-lg font-bold tracking-wide" data-id="element-100">
              ✦ Edición Completa — Bonos exclusivos ✦
            </div>
            <p className="text-center text-[13px] text-carbon-soft mt-3 px-4" data-id="element-101">
              Dos bonos más para acompañar el cambio, incluidos al elegir la
              Edición Completa.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-102">
            <BonusCard num="5" title="Cuentos para leer juntos — 10 historias que abren conversaciones" desc="10 cuentos cortos escritos para leer en voz alta. Cada cuento trabaja un tema diferente: el aburrimiento, la imaginación, la naturaleza, el vínculo, la espera, el juego, el error y el perdón, los rituales, la presencia, el tiempo con el otro. Al final de cada cuento: una pregunta para conversar, sin respuesta correcta. Para niños de 3 a 10 años." isExclusive data-id="element-103" />
            <BonusCard num="6" title="Guía para docentes — Cómo hablar del tema con las familias sin generar conflicto" desc="Para maestras y maestros de nivel inicial y primario. Incluye: el encuadre que abre vs el que cierra · 6 modelos de comunicación listos para usar · respuestas a las preguntas más frecuentes de las familias · estrategias concretas para el aula · herramienta de planificación imprimible para antes de una reunión de padres." isExclusive data-id="element-104" />
          </div>
        </div>
      </section>

      {/* SYSTEM SUMMARY — brand block */}
      <section className="relative bg-carbon py-20 px-6 overflow-hidden" data-id="element-105">
        {/* soft glow accents */}
        <div className="pointer-events-none absolute -top-24 left-1/2 -translate-x-1/2 w-[520px] h-[520px] rounded-full bg-terra/10 blur-[120px]" data-id="element-106" />
        <div className="pointer-events-none absolute bottom-0 right-0 w-[360px] h-[360px] rounded-full bg-sage/10 blur-[120px]" data-id="element-107" />

        <div className="relative max-w-[880px] mx-auto flex flex-col items-center text-center" data-id="element-108">
          {/* badge */}
          <div className="inline-flex items-center gap-2 border border-terra/40 bg-terra/10 text-terra-mid text-[11px] sm:text-xs font-bold tracking-widest uppercase py-2 px-4 rounded-full mb-10" data-id="element-109">
            <Trophy size={14} data-id="element-110" />
            Sistema Nº1 en Argentina
          </div>

          {/* subtitle */}
          <p className="text-base sm:text-lg md:text-xl text-cream/70 mb-9 max-w-[640px] leading-relaxed" data-id="element-111">
            Sistema completo · 6 Tomos + 2 Exclusivos · Para familias y docentes
            ·{' '}
            <span className="text-terra-mid font-semibold" data-id="element-112">Todo resuelto.</span>
          </p>

          {/* DigSol logo */}
          <div className="flex justify-center w-full mb-10" data-id="element-113">
            <img src="https://cdn.magicpatterns.com/uploads/1EefBDD43hUwUa7WseZgGG/ChatGPT_Image_28_jun_2026,_05_24_17-fotor-bg-remover-20260628152437.png" alt="DigSol — Tu solución digital" className="h-40 sm:h-48 md:h-56 w-auto object-contain mt-[-30px] mb-[-30px]" data-id="element-114" />
          </div>

          {/* stat pills */}
          <div className="flex flex-wrap justify-center gap-3 sm:gap-4 mb-10" data-id="element-115">
            <div className="flex items-center gap-2.5 bg-white/[0.04] border border-white/10 rounded-xl py-3 px-5" data-id="element-116">
              <BookOpen size={20} className="text-terra-mid shrink-0" data-id="element-117" />
              <span className="font-serif text-base sm:text-lg font-bold text-cream" data-id="element-118">
                +210 PÁG.
              </span>
            </div>
            <div className="flex items-center gap-2.5 bg-white/[0.04] border border-white/10 rounded-xl py-3 px-5" data-id="element-119">
              <Dumbbell size={20} className="text-terra-mid shrink-0" data-id="element-120" />
              <span className="font-serif text-base sm:text-lg font-bold text-cream" data-id="element-121">
                100+ ACTIVIDADES
              </span>
            </div>
            <div className="flex items-center gap-2.5 bg-white/[0.04] border border-white/10 rounded-xl py-3 px-5" data-id="element-122">
              <Sparkles size={20} className="text-terra-mid shrink-0" data-id="element-123" />
              <span className="font-serif text-base sm:text-lg font-bold text-cream" data-id="element-124">
                50 FRASES LISTAS
              </span>
            </div>
          </div>

          {/* topic pills */}
          <div className="flex flex-wrap justify-center gap-2.5 max-w-[760px] mb-10" data-id="element-125">
            {['Límites claros', 'Sin gritos', 'Por edad', 'Plan 4 semanas', 'Abuelos', 'Cumpleaños', 'Frases reales', 'Juego libre', 'Rutinas', 'Primera pantalla', 'Para docentes', 'Sin culpa'].map(topic => <span key={topic} className="bg-white/[0.04] border border-white/10 text-cream/80 text-sm py-1.5 px-3.5 rounded-lg" data-id="element-126">
                {topic}
              </span>)}
          </div>

          {/* closing line */}
          <p className="font-semibold text-cream text-base sm:text-lg" data-id="element-127">
            Funciona desde hoy, en tu casa, con lo que ya tenés a mano.
          </p>
        </div>
      </section>

      {/* COMPARISON */}
      <section className="py-20 px-6 bg-cream" data-id="element-128">
        <div className="max-w-[780px] mx-auto" data-id="element-129">
          <p className="text-[11px] font-bold tracking-widest uppercase text-terra mb-3" data-id="element-130">
            La realidad
          </p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold leading-tight mb-10 text-carbon" data-id="element-131">
            ¿Cuánto cuesta no tenerlo?
          </h2>

          <div className="mt-10 rounded-xl overflow-hidden border border-border" data-id="element-132">
            <div className="grid grid-cols-2" data-id="element-133">
              <div className="font-bold text-sm uppercase tracking-wider p-4 md:p-5 bg-sand text-carbon-soft border-r border-border border-b" data-id="element-134">
                Sin Jugar, Crecer, Conectar
              </div>
              <div className="font-bold text-sm uppercase tracking-wider p-4 md:p-5 bg-sage text-white border-b border-border" data-id="element-135">
                Con Jugar, Crecer, Conectar
              </div>
            </div>
            <CompRow bad="Cada noche termina en conflicto por la pantalla" good="Un límite claro, con frases listas, sin escalada" data-id="element-136" />
            <CompRow bad='No sabés qué proponer cuando dicen "me aburro"' good="100 actividades + 20 tarjetas exprés listas para usar" data-id="element-137" />
            <CompRow bad="Culpa constante sin saber cómo cambiar nada" good="Un plan de 4 semanas paso a paso, adaptable" data-id="element-138" />
            <CompRow bad="Los abuelos hacen lo que quieren y el niño lo aprovecha" good="Estrategia concreta para alinear a todos los adultos" data-id="element-139" />
            <CompRow bad="Buscás en Google y encontrás información contradictoria" good="Todo en un solo lugar, en lenguaje de familia, sin tecnicismos" data-id="element-140" />
            <CompRow bad="El mismo conflicto de pantalla mañana, pasado y siempre" good="En 4 semanas, una dinámica familiar diferente" isLast data-id="element-141" />
          </div>
        </div>
      </section>

      {/* PRICING — buy options only */}
      <section id="pricing" className="bg-[#111111] py-20 px-6 border-t border-border" data-id="element-142">
        <div className="max-w-[780px] mx-auto text-center" data-id="element-143">
          <p className="text-[11px] font-bold tracking-widest uppercase text-terra mb-3" data-id="element-144">
            Elegí tu edición
          </p>
          <h2 className="font-serif text-3xl md:text-4xl font-black leading-tight mb-3 text-white" data-id="element-145">
            Empezá hoy
          </h2>
          <p className="text-base text-gray-400 mb-10 max-w-[480px] mx-auto" data-id="element-146">
            Un pago único, acceso inmediato y todo el material para empezar el
            cambio esta misma tarde.
          </p>
          <div className="text-left" data-id="element-147">
            <OfferSelector variant="dark" data-id="element-148" />
          </div>
        </div>
      </section>

      {/* GUARANTEE */}
      <section id="guarantee" className="bg-cream py-20 px-6 border-t border-border" data-id="element-149">
        <div className="max-w-[640px] mx-auto bg-white border-2 border-sage rounded-2xl p-8 md:p-12 text-center" data-id="element-150">
          <ShieldCheck className="mx-auto text-sage mb-4" size={48} data-id="element-151" />
          <h3 className="font-serif text-3xl font-bold text-carbon mb-4" data-id="element-152">
            7 días de garantía total
          </h3>
          <p className="text-base text-carbon-soft leading-relaxed mb-4" data-id="element-153">
            Abrís los tomos, probás las actividades, usás las frases en el
            primer momento difícil. Si no es lo que esperabas — sin preguntas,
            sin formularios, sin drama — te devolvemos el 100% de lo que
            pagaste.
          </p>
          <p className="text-[13px] text-sage font-medium mt-4" data-id="element-154">
            Tasa de devoluciones menor al 1%
          </p>
        </div>
      </section>

      {/* FAQ */}
      <section className="bg-sand py-20 px-6 border-y border-border" data-id="element-155">
        <div className="max-w-[680px] mx-auto" data-id="element-156">
          <p className="text-[11px] font-bold tracking-widest uppercase text-terra mb-3 text-center" data-id="element-157">
            Dudas comunes
          </p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold leading-tight mb-10 text-center text-carbon" data-id="element-158">
            Preguntas frecuentes
          </h2>

          <div className="flex flex-col" data-id="element-159">
            <FaqItem q="¿Cómo recibo el material después de comprar?" a="Inmediatamente después del pago recibís un email con el link de descarga de todos los PDFs. No hay plataforma ni usuario ni contraseña — los archivos son tuyos para siempre." data-id="element-160" />
            <FaqItem q="¿Para qué edades es útil?" a="Todo el material está pensado para niños de 2 a 12 años. Las actividades y las estrategias están organizadas por rango de edad para que encuentres exactamente lo que necesitás según el momento de desarrollo de tu hijo." data-id="element-161" />
            <FaqItem q="¿Necesito leerlo todo antes de que algo cambie?" a="No. Cada tomo es independiente. Podés empezar por el Tomo 4 (100 actividades) hoy mismo y ya tenés algo para usar esta tarde. O por el Bono 1 (50 frases) para la próxima vez que tu hijo llore al apagar la tele." data-id="element-162" />
            <FaqItem q="¿Sirve si mi hijo tiene menos de 2 años?" a="El material principal está pensado para niños de 2 a 12 años. Si tu hijo tiene menos de 2, el Tomo 1 tiene información muy relevante sobre las recomendaciones de la OMS para esa etapa. El resto del material aplica mejor a partir de los 2 años." data-id="element-163" />
            <FaqItem q="¿Qué diferencia hay entre la Edición Esencial y la Completa?" a="La Edición Esencial tiene los 6 tomos principales y los 4 bonos — todo lo que necesitás para cambiar el hábito de pantallas en 4 semanas. La Edición Completa suma 2 tomos exclusivos (vínculos y primera pantalla) y 2 bonos adicionales (cuentos para leer juntos y guía para docentes). Si tenés hijos en edad escolar o sos docente, la Completa vale la diferencia." data-id="element-164" />
            <FaqItem q="¿Funciona si mi pareja no comparte mi visión sobre las pantallas?" a="Sí, y justamente el Tomo 5 trabaja ese escenario en profundidad. Hay una sección completa sobre cómo llegar a un acuerdo mínimo con el otro adulto del hogar — sin que nadie sienta que perdió." data-id="element-165" />
            <FaqItem q="¿Tiene garantía real?" a="Sí. 7 días completos para probarlo. Si no es lo que esperabas, escribinos y te devolvemos el 100% sin preguntas. La tasa de devoluciones es menor al 1% — no porque sea difícil pedirla, sino porque el material funciona." data-id="element-166" />
            <FaqItem q="¿Puedo imprimirlo?" a="Sí. Los PDFs están diseñados para verse bien en pantalla y también impresos. De hecho, el Bono 2 (rutina semanal) y el Bono 3 (tarjetas exprés) están pensados para imprimirse y pegarse en la heladera." isLast data-id="element-167" />
          </div>
        </div>
      </section>

      {/* FINAL CTA — countdown + offer */}
      <section className="bg-[#111111] py-20 px-6 text-center border-t border-border" data-id="element-168">
        <div className="max-w-[780px] mx-auto" data-id="element-169">
          <CountdownSection data-id="element-170" />
        </div>
      </section>

      {/* FOOTER */}
      <footer className="bg-cream border-t border-border py-8 px-6 text-center text-[13px] text-carbon-soft" data-id="element-171">
        <p className="mb-2.5" data-id="element-172">
          <strong className="text-carbon font-semibold" data-id="element-173">
            Jugar, Crecer, Conectar™
          </strong>{' '}
          — digsol.shop · Tu solución digital
          <br className="md:hidden" data-id="element-174" />
          <span className="hidden md:inline" data-id="element-175"> · </span>
          <a href="#" className="text-terra hover:underline" data-id="element-176">
            soportedigsol@gmail.com
          </a>{' '}
          ·
          <a href="#" className="text-terra hover:underline ml-1" data-id="element-177">
            Términos y condiciones
          </a>{' '}
          ·
          <a href="#" className="text-terra hover:underline ml-1" data-id="element-178">
            Política de privacidad
          </a>
        </p>
        <p data-id="element-179">© digsol.shop 2026 — Todos los derechos reservados.</p>
      </footer>

      <PurchasePopup data-id="element-180" />
    </div>;
}
// Subcomponents
function TestimonialCard({
  quote,
  author,
  role
}: {
  quote: string;
  author: string;
  role: string;
}) {
  return <div className="bg-white rounded-xl p-7 border border-border" data-id="element-181">
      <div className="text-terra text-sm mb-3 flex gap-0.5" data-id="element-182">
        <Star size={14} fill="currentColor" data-id="element-183" />
        <Star size={14} fill="currentColor" data-id="element-184" />
        <Star size={14} fill="currentColor" data-id="element-185" />
        <Star size={14} fill="currentColor" data-id="element-186" />
        <Star size={14} fill="currentColor" data-id="element-187" />
      </div>
      <p className="text-[15px] leading-relaxed text-carbon-soft mb-5 italic" data-id="element-188">
        "{quote}"
      </p>
      <div data-id="element-189">
        <strong className="block text-sm font-semibold text-carbon" data-id="element-190">
          {author}
        </strong>
        <span className="text-xs text-terra" data-id="element-191">{role}</span>
      </div>
    </div>;
}
function PainItem({
  title,
  desc
}: {
  title: string;
  desc: string;
}) {
  return <div className="bg-sand rounded-lg p-5 border-l-4 border-terra" data-id="element-192">
      <strong className="block text-sm font-semibold text-carbon mb-1.5" data-id="element-193">
        {title}
      </strong>
      <p className="text-sm text-carbon-soft" data-id="element-194">{desc}</p>
    </div>;
}
function ForWhomCard({
  icon,
  title,
  desc
}: {
  icon: React.ReactNode;
  title: string;
  desc: string;
}) {
  return <div className="bg-white rounded-xl p-6 border border-border" data-id="element-195">
      <div className="mb-3" data-id="element-196">{icon}</div>
      <strong className="block text-[15px] font-semibold text-carbon mb-1.5" data-id="element-197">
        {title}
      </strong>
      <p className="text-sm text-carbon-soft" data-id="element-198">{desc}</p>
    </div>;
}
function StatItem({
  num,
  label
}: {
  num: string;
  label: string;
}) {
  return <div data-id="element-199">
      <div className="font-serif text-4xl font-black text-terra-mid leading-none" data-id="element-200">
        {num}
      </div>
      <div className="text-[13px] text-gray-400 mt-1.5" data-id="element-201">{label}</div>
    </div>;
}
function ModuleItem({
  num,
  title,
  desc,
  tags,
  defaultOpen = false,
  isExclusive = false
}: {
  num: string;
  title: string;
  desc: string;
  tags: string[];
  defaultOpen?: boolean;
  isExclusive?: boolean;
}) {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  const contentId = `module-panel-${num}`;
  const borderColor = isExclusive ? 'border-sage shadow-[0_6px_24px_rgba(122,158,126,0.10)]' : 'border-terra shadow-[0_6px_24px_rgba(193,96,58,0.10)]';
  const focusRing = isExclusive ? 'focus-visible:ring-sage/40' : 'focus-visible:ring-terra/40';
  const badgeBg = isExclusive ? isOpen ? 'bg-sage text-white' : 'bg-sage-light text-sage' : isOpen ? 'bg-terra text-white' : 'bg-terra-light text-terra';
  const labelColor = isExclusive ? 'text-sage/70' : 'text-terra/70';
  return <div className={`bg-white rounded-xl border overflow-hidden transition-colors duration-200 ${isOpen ? borderColor : 'border-border'}`} data-id="element-202">
      <button type="button" onClick={() => setIsOpen(v => !v)} aria-expanded={isOpen} aria-controls={contentId} className={`w-full flex items-center gap-3 p-3 sm:p-4 text-left rounded-xl focus:outline-none focus-visible:ring-2 ${focusRing}`} data-id="element-203">
        <span className={`font-serif text-base sm:text-lg font-bold w-9 h-9 sm:w-11 sm:h-11 rounded-lg flex items-center justify-center shrink-0 transition-colors duration-200 ${badgeBg}`} data-id="element-204">
          {num}
        </span>
        <span className="flex-1 min-w-0" data-id="element-205">
          <span className={`block text-[10px] font-bold tracking-widest uppercase leading-none mb-1 ${labelColor}`} data-id="element-206">
            Tomo {num} {isExclusive && '· EXCLUSIVO · EDICIÓN COMPLETA'}
          </span>
          <span className="block text-sm sm:text-[15px] font-semibold text-carbon leading-snug" data-id="element-207">
            {title}
          </span>
        </span>
        <ChevronDown size={20} className={`text-carbon-soft shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-208" />
      </button>

      <AnimatePresence initial={false} data-id="element-209">
        {isOpen && <motion.div id={contentId} key="content" initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.28,
        ease: [0.4, 0, 0.2, 1]
      }} className="overflow-hidden" data-id="element-210">
            <div className="px-3 sm:px-4 pb-4 pl-[60px] sm:pl-[72px]" data-id="element-211">
              <p className="text-sm text-carbon-soft mb-3" data-id="element-212">{desc}</p>
              <div className="flex flex-wrap gap-1.5" data-id="element-213">
                {tags.map((tag, idx) => <span key={idx} className="text-[11px] font-medium py-1 px-2.5 rounded-full bg-sand text-carbon-soft" data-id="element-214">
                    {tag}
                  </span>)}
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
function BonusCard({
  num,
  title,
  desc,
  isExclusive = false
}: {
  num: string;
  title: string;
  desc: string;
  isExclusive?: boolean;
}) {
  const [isOpen, setIsOpen] = useState(false);
  const contentId = `bonus-panel-${num}`;
  return <div className={`bg-white rounded-xl border overflow-hidden transition-colors duration-200 ${isOpen ? 'border-sage shadow-[0_6px_24px_rgba(122,158,126,0.10)]' : 'border-border'}`} data-id="element-215">
      <button type="button" onClick={() => setIsOpen(v => !v)} aria-expanded={isOpen} aria-controls={contentId} className="w-full flex items-start gap-3 p-5 sm:p-6 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-sage/40" data-id="element-216">
        <div className="flex-1 min-w-0" data-id="element-217">
          <div className="text-[10px] font-bold tracking-widest uppercase text-sage mb-2" data-id="element-218">
            {isExclusive ? `Bono ${num} · EXCLUSIVO · EDICIÓN COMPLETA` : `Bono ${num} · GRATIS`}
          </div>
          <strong className="block text-sm font-semibold text-carbon" data-id="element-219">
            {title}
          </strong>
        </div>
        <ChevronDown size={20} className={`text-carbon-soft shrink-0 mt-1 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-220" />
      </button>

      <AnimatePresence initial={false} data-id="element-221">
        {isOpen && <motion.div id={contentId} key="content" initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.28,
        ease: [0.4, 0, 0.2, 1]
      }} className="overflow-hidden" data-id="element-222">
            <div className="px-5 sm:px-6 pb-5 sm:pb-6 pt-0" data-id="element-223">
              <p className="text-[13px] text-carbon-soft" data-id="element-224">{desc}</p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
function CompRow({
  bad,
  good,
  isLast = false
}: {
  bad: string;
  good: string;
  isLast?: boolean;
}) {
  return <div className="grid grid-cols-2" data-id="element-225">
      <div className={`p-4 md:p-5 text-sm bg-[#FFF5F0] text-carbon-soft border-r border-border flex items-start gap-2.5 ${!isLast ? 'border-b' : ''}`} data-id="element-226">
        <span className="text-red-500 shrink-0 mt-0.5" data-id="element-227">❌</span>
        <span data-id="element-228">{bad}</span>
      </div>
      <div className={`p-4 md:p-5 text-sm bg-sage-light text-carbon font-medium flex items-start gap-2.5 ${!isLast ? 'border-b border-border' : ''}`} data-id="element-229">
        <span className="text-sage shrink-0 mt-0.5" data-id="element-230">✓</span>
        <span data-id="element-231">{good}</span>
      </div>
    </div>;
}
type OfferId = 'esencial' | 'completa';
const OFFERS: {
  id: OfferId;
  name: string;
  desc: string;
  oldPrice: string;
  price: string;
  url: string;
  popular: boolean;
}[] = [{
  id: 'esencial',
  name: 'Edición Esencial',
  desc: '6 tomos + 4 bonos · 10 PDFs · 170 págs',
  oldPrice: '$29.990',
  price: '$19.990',
  url: 'https://checkout.digsol.shop/cart/45224063467702:1',
  popular: false
}, {
  id: 'completa',
  name: 'Edición Completa',
  desc: '+ 2 tomos y 2 bonos exclusivos · 14 PDFs · 250 págs',
  oldPrice: '$43.990',
  price: '$29.990',
  url: 'https://checkout.digsol.shop/cart/45224063566006:1',
  popular: true
}];
function OfferSelector({
  variant = 'light'
}: {
  variant?: 'light' | 'dark';
}) {
  const [selected, setSelected] = useState<OfferId>('completa');
  const isDark = variant === 'dark';
  const activeOffer = OFFERS.find(o => o.id === selected) ?? OFFERS[1];
  const handleBuy = () => {
    window.location.href = activeOffer.url;
  };
  return <div className="max-w-[500px] mx-auto" data-id="element-232">
      <div role="radiogroup" aria-label="Elegí tu edición" className="flex flex-col gap-4" data-id="element-233">
        {OFFERS.map(offer => {
        const isSelected = offer.id === selected;
        return <button key={offer.id} type="button" role="radio" aria-checked={isSelected} onClick={() => setSelected(offer.id)} className={`relative w-full text-left rounded-xl border p-4 flex items-center gap-4 transition-all duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-terra/50 ${isSelected ? 'border-terra bg-[#1A1A1A]' : 'border-white/10 bg-transparent hover:border-white/20'}`} data-id="element-234">
              {/* radio dot */}
              <span className={`mt-0.5 w-5 h-5 rounded-full border-2 shrink-0 flex items-center justify-center transition-colors ${isSelected ? 'border-terra' : 'border-gray-500'}`} data-id="element-235">
                {isSelected && <span className="w-2.5 h-2.5 rounded-full bg-terra" data-id="element-236" />}
              </span>

              <span className="flex-1 min-w-0" data-id="element-237">
                <span className={`block text-base font-bold leading-tight uppercase tracking-wide ${isSelected ? 'text-white' : 'text-gray-300'}`} data-id="element-238">
                  {offer.name}
                </span>
                <span className={`block text-xs mt-1 leading-snug text-gray-400`} data-id="element-239">
                  {offer.desc}
                </span>
                {offer.popular && isSelected && <div className="flex gap-2 mt-2" data-id="element-240">
                    <span className="bg-terra text-white text-[10px] font-bold tracking-wider uppercase py-0.5 px-2 rounded-sm whitespace-nowrap" data-id="element-241">
                      ⭐ MÁS ELEGIDO
                    </span>
                    <span className="bg-green-700 text-white text-[10px] font-bold tracking-wider uppercase py-0.5 px-2 rounded-sm whitespace-nowrap" data-id="element-242">
                      AHORRÁS $14.000
                    </span>
                  </div>}
              </span>

              <span className="text-right shrink-0" data-id="element-243">
                <span className="block text-xs text-gray-500 line-through leading-none mb-1" data-id="element-244">
                  {offer.oldPrice}
                </span>
                <span className={`block font-sans text-2xl font-bold leading-tight ${isSelected ? 'text-terra' : 'text-white'}`} data-id="element-245">
                  {offer.price}
                </span>
              </span>
            </button>;
      })}
      </div>

      <button type="button" onClick={handleBuy} className="mt-6 w-full bg-terra text-white font-bold text-lg py-4 px-6 rounded-lg hover:bg-terra-dark hover:-translate-y-0.5 transition-all duration-200 tracking-wide uppercase" data-id="element-246">
        SÍ, QUIERO {activeOffer.name} →
      </button>
      <p className="text-center text-xs text-gray-400 mt-3 mb-4" data-id="element-247">
        La opción más elegida por familias que buscan un cambio real
      </p>

      <div className={`flex justify-center gap-6 flex-wrap text-xs mt-4 text-gray-500`} data-id="element-248">
        <span className="flex items-center gap-1.5" data-id="element-249">
          <Lock size={14} className="text-terra" data-id="element-250" /> Pago seguro
        </span>
        <span className="flex items-center gap-1.5" data-id="element-251">
          <Zap size={14} className="text-terra" data-id="element-252" /> Acceso en 5 min
        </span>
        <span className="flex items-center gap-1.5" data-id="element-253">
          <ShieldCheck size={14} className="text-terra" data-id="element-254" /> Garantía 7 días
        </span>
      </div>
    </div>;
}
function FaqItem({
  q,
  a,
  isLast = false
}: {
  q: string;
  a: string;
  isLast?: boolean;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className={`py-5 ${!isLast ? 'border-b border-border' : ''}`} data-id="element-255">
      <button className="w-full text-left flex justify-between items-center gap-4 focus:outline-none" onClick={() => setIsOpen(!isOpen)} data-id="element-256">
        <span className="text-base font-semibold text-carbon" data-id="element-257">{q}</span>
        <ChevronDown className={`text-carbon-soft shrink-0 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} size={20} data-id="element-258" />
      </button>
      {isOpen && <p className="mt-3 text-[15px] text-carbon-soft leading-relaxed pr-8" data-id="element-259">
          {a}
        </p>}
    </div>;
}
const TESTIMONIALS = [{
  quote: 'La primera semana ya noté que la hora de la cena era diferente. Menos conflicto, más charla. Y eso que todavía no había llegado al tomo 3.',
  author: 'Valeria M.',
  role: 'Buenos Aires — Mamá de dos niños de 4 y 7 años'
}, {
  quote: 'Lo compré pensando que era otro libro de crianza. No lo es. Tiene frases concretas para decir cuando mi hijo llora al apagar la tele. Eso cambió todo.',
  author: 'Rodrigo P.',
  role: 'Rosario — Papá de una nena de 6 años'
}, {
  quote: 'Lo usé como material de apoyo para hablar con los padres de mis alumnos. La guía para docentes es exactamente lo que necesitaba para tener esa conversación sin que nadie se sintiera atacado.',
  author: 'Florencia T.',
  role: 'Córdoba — Maestra de nivel inicial'
}, {
  quote: 'En dos semanas mi hija empezó a pedirme que jugáramos a las cartas antes de cenar. Algo que nunca había pasado. No lo podía creer.',
  author: 'Luciana R.',
  role: 'Mendoza — Mamá de una nena de 8 años'
}, {
  quote: "Las tarjetas de actividades exprés son un golazo. Las pegué en la heladera y ahora cuando mi hijo dice 'me aburro', él mismo va a elegir una. Ya no soy yo el que tiene que inventar algo.",
  author: 'Martín G.',
  role: 'La Plata — Papá de mellizos de 5 años'
}, {
  quote: 'Pensé que iba a ser imposible cambiar algo tan instalado. El plan de 4 semanas hace que no parezca tan grande. Empezás por una sola cosa y de a poco se va acomodando todo.',
  author: 'Sofía C.',
  role: 'San Miguel de Tucumán — Mamá de tres hijos de 3, 7 y 10 años'
}];
function TestimonialsSlider() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
  const next = useCallback(() => {
    setCurrentIndex(prev => (prev + 1) % TESTIMONIALS.length);
  }, []);
  const prev = () => {
    setCurrentIndex(prev => (prev - 1 + TESTIMONIALS.length) % TESTIMONIALS.length);
  };
  useEffect(() => {
    if (isHovered) return;
    const timer = setInterval(next, 5000);
    return () => clearInterval(timer);
  }, [isHovered, next]);
  return <div className="relative max-w-[600px] mx-auto" onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)} data-id="element-260">
      <div className="overflow-hidden relative min-h-[280px] sm:min-h-[240px]" data-id="element-261">
        <AnimatePresence mode="wait" data-id="element-262">
          <motion.div key={currentIndex} initial={{
          opacity: 0,
          x: 50
        }} animate={{
          opacity: 1,
          x: 0
        }} exit={{
          opacity: 0,
          x: -50
        }} transition={{
          duration: 0.3
        }} className="absolute inset-0 w-full" data-id="element-263">
            <TestimonialCard {...TESTIMONIALS[currentIndex]} data-id="element-264" />
          </motion.div>
        </AnimatePresence>
      </div>

      <div className="flex justify-center items-center gap-4 mt-6" data-id="element-265">
        <button onClick={prev} className="p-2 rounded-full bg-white border border-border text-carbon-soft hover:text-terra hover:border-terra transition-colors focus:outline-none" data-id="element-266">
          <ChevronLeft size={20} data-id="element-267" />
        </button>
        <div className="flex gap-2" data-id="element-268">
          {TESTIMONIALS.map((_, idx) => <button key={idx} onClick={() => setCurrentIndex(idx)} className={`w-2.5 h-2.5 rounded-full transition-colors focus:outline-none ${idx === currentIndex ? 'bg-terra' : 'bg-border hover:bg-terra-light'}`} data-id="element-269" />)}
        </div>
        <button onClick={next} className="p-2 rounded-full bg-white border border-border text-carbon-soft hover:text-terra hover:border-terra transition-colors focus:outline-none" data-id="element-270">
          <ChevronRight size={20} data-id="element-271" />
        </button>
      </div>
    </div>;
}
function CountdownSection() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 48,
    seconds: 0
  });
  useEffect(() => {
    const endTimeKey = 'digsol_offer_end_time';
    let endTime = localStorage.getItem(endTimeKey);
    if (!endTime) {
      const newEndTime = new Date().getTime() + 23 * 60 * 60 * 1000 + 48 * 60 * 1000;
      localStorage.setItem(endTimeKey, newEndTime.toString());
      endTime = newEndTime.toString();
    }
    const updateTimer = () => {
      const now = new Date().getTime();
      const distance = parseInt(endTime!) - now;
      if (distance < 0) {
        setTimeLeft({
          hours: 0,
          minutes: 0,
          seconds: 0
        });
        return;
      }
      const hours = Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
      const minutes = Math.floor(distance % (1000 * 60 * 60) / (1000 * 60));
      const seconds = Math.floor(distance % (1000 * 60) / 1000);
      setTimeLeft({
        hours,
        minutes,
        seconds
      });
    };
    updateTimer();
    const interval = setInterval(updateTimer, 1000);
    return () => clearInterval(interval);
  }, []);
  const formatNumber = (num: number) => num.toString().padStart(2, '0');
  return <div className="max-w-[600px] mx-auto text-center" data-id="element-272">
      <h2 className="font-sans text-2xl md:text-3xl font-bold leading-tight mb-2 text-white uppercase tracking-wide" data-id="element-273">
        NO DEJES PASAR ESTA OPORTUNIDAD
      </h2>
      <p className="text-sm font-medium tracking-widest uppercase text-gray-400 mb-8" data-id="element-274">
        TERMINA EN
      </p>

      <div className="flex justify-center items-center gap-3 md:gap-5 mb-10" data-id="element-275">
        <div className="flex flex-col items-center" data-id="element-276">
          <div className="border border-white/10 w-16 h-16 md:w-20 md:h-20 rounded-xl flex items-center justify-center" data-id="element-277">
            <span className="font-sans text-3xl md:text-4xl font-bold text-terra" data-id="element-278">
              {formatNumber(timeLeft.hours)}
            </span>
          </div>
          <span className="text-[10px] uppercase tracking-widest mt-3 text-gray-500 font-medium" data-id="element-279">
            Horas
          </span>
        </div>
        <div className="text-2xl md:text-3xl font-bold mb-8 text-terra/50" data-id="element-280">
          :
        </div>
        <div className="flex flex-col items-center" data-id="element-281">
          <div className="border border-white/10 w-16 h-16 md:w-20 md:h-20 rounded-xl flex items-center justify-center" data-id="element-282">
            <span className="font-sans text-3xl md:text-4xl font-bold text-terra" data-id="element-283">
              {formatNumber(timeLeft.minutes)}
            </span>
          </div>
          <span className="text-[10px] uppercase tracking-widest mt-3 text-gray-500 font-medium" data-id="element-284">
            Min
          </span>
        </div>
        <div className="text-2xl md:text-3xl font-bold mb-8 text-terra/50" data-id="element-285">
          :
        </div>
        <div className="flex flex-col items-center" data-id="element-286">
          <div className="border border-white/10 w-16 h-16 md:w-20 md:h-20 rounded-xl flex items-center justify-center" data-id="element-287">
            <span className="font-sans text-3xl md:text-4xl font-bold text-terra" data-id="element-288">
              {formatNumber(timeLeft.seconds)}
            </span>
          </div>
          <span className="text-[10px] uppercase tracking-widest mt-3 text-gray-500 font-medium" data-id="element-289">
            Seg
          </span>
        </div>
      </div>

      <OfferSelector variant="dark" data-id="element-290" />
    </div>;
}
const NAMES = ['María', 'Florencia', 'Juan', 'Sofía', 'Lucas', 'Camila', 'Martín', 'Luciana', 'Agustín', 'Valentina', 'Micaela', 'Facundo', 'Julieta', 'Tomás', 'Carolina'];
const LOCATIONS = ['Buenos Aires', 'CABA', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Tucumán', 'Mar del Plata', 'Salta', 'Santa Fe', 'San Juan', 'Neuquén', 'Neuquén', 'Bariloche'];
const OFFERS_POPUP = ['Edición Esencial', 'Edición Completa'];
function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [purchaseData, setPurchaseData] = useState({
    name: '',
    location: '',
    offer: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomLocation = LOCATIONS[Math.floor(Math.random() * LOCATIONS.length)];
      const randomOffer = OFFERS_POPUP[Math.floor(Math.random() * OFFERS_POPUP.length)];
      setPurchaseData({
        name: randomName,
        location: randomLocation,
        offer: randomOffer
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    const scheduleNextPopup = () => {
      const delay = Math.floor(Math.random() * (60000 - 40000 + 1)) + 40000; // 40-60 seconds
      setTimeout(() => {
        showPopup();
        scheduleNextPopup();
      }, delay);
    };
    // Initial delay before first popup
    const initialDelay = Math.floor(Math.random() * 10000) + 5000;
    const timer = setTimeout(() => {
      showPopup();
      scheduleNextPopup();
    }, initialDelay);
    return () => clearTimeout(timer);
  }, []);
  return <AnimatePresence data-id="element-291">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      duration: 0.4,
      ease: [0.4, 0, 0.2, 1]
    }} className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:bottom-6 z-50 max-w-[320px] bg-white rounded-xl shadow-[0_8px_30px_rgba(0,0,0,0.12)] border border-border p-4 flex items-start gap-3" data-id="element-292">
          <div className="bg-sage/10 p-2 rounded-full shrink-0" data-id="element-293">
            <ShieldCheck className="text-sage" size={20} data-id="element-294" />
          </div>
          <div className="flex-1 min-w-0 pr-4" data-id="element-295">
            <p className="text-[11px] font-bold tracking-widest uppercase text-sage mb-1" data-id="element-296">
              Compra verificada
            </p>
            <p className="text-sm text-carbon leading-snug" data-id="element-297">
              <strong data-id="element-298">{purchaseData.name}</strong> de {purchaseData.location}{' '}
              acaba de comprar la <strong data-id="element-299">{purchaseData.offer}</strong>.
            </p>
            <p className="text-xs text-carbon-soft mt-1" data-id="element-300">Hace un momento</p>
          </div>
          <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 p-1 text-gray-400 hover:text-carbon transition-colors focus:outline-none" data-id="element-301">
            <X size={14} data-id="element-302" />
          </button>
        </motion.div>}
    </AnimatePresence>;
}